import React from "react";
import Navbar from "../layout/Navbar";
import revolution2 from "../assests/Images/RevolutionizingSales_Project2.jpg";
import { LuNewspaper } from "react-icons/lu";
import orsac from "../assests/Images/ORSAC_Project.jpg";
import Redefining_Project2 from "../assests/Images/Redefining_Project2.jpg";
import { Link } from "react-router-dom";
import StrategicOverhaul_Project1 from "../assests/Images/Strategic_Overhaul_Project1.jpg";
import StrategicOverhaul_Project2 from "../assests/Images/Strategic_Overhaul_Project2.jpg";
import Footer from "../layout/Footer";
import WaveEffect from "../Components/WaveEffect";

const StrategicOverhaulProject = () => {
  return (
    <div>
      <Navbar />
      <div
        className="bg-cover bg-center h-[50vh] lg:h-[75vh] md:h-[60vh] sm:h-[400px] rounded-tl-[390px] md:rounded-tl-[500px] lg:rounded-tl-[500px]"
        style={{ backgroundImage: `url(${StrategicOverhaul_Project1})` }}
      >
        <div className="h-full bg-black bg-opacity-80 w-full flex flex-col justify-center items-center sm:rounded-tl-[390px] lg:rounded-tl-[390px]">
          <WaveEffect
            text="Strategic Overhaul"
            textClassName="text-white text-xl lg:text-5xl xl:text-5xl 2xl:text-3xl sm:text-3xl 2xl:text-8xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-4 w-24 bg-white" />
        </div>
      </div>

      <div className="mt-10 xl:m-28 lg:m-20 md:m-16 sm:m-10 flex flex-col xl:flex-row lg:flex-row md:flex-col sm:flex-col gap-20 h-full sm:mt-10 ">
        <div className="w-full ">
          <img
            src={StrategicOverhaul_Project2}
            alt=""
            className="lg:h-[35rem] h-full w-full rounded-xl object-cover"
          />
        </div>

        <div className="flex justify-center">
          <div className="w-[20rem] h-fit shadow-lg p-10 md:w-[25rem]  sm:w-[20rem]  place-items-center ">
            <div className="flex flex-row gap-2 justify-start items-center border-b-2 border-gray-300">
              <LuNewspaper className="text-2xl text-primary" />
              <h1 className="text-2xl font-bold pb-4 text-center">
                Recent Case Studies
              </h1>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={orsac}
                alt=""
                className=" h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">April 3, 2025</h1>
                <Link to="/orsac-project" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">GIS & Remote Sensing Applications</h1>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={revolution2}
                alt=""
                className=" h-16 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link to="/redefining-productivity-incentives" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">
                    Redefining Productivity Incentives
                  </h1>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 py-5">
              <img
                src={Redefining_Project2}
                alt=""
                className="h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link to="/revolutionizing-sales-operations" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">
                    Revolutionizing Sales Operations
                  </h1>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center text-start gap-10 lg:px-28 p-5 text-lg mb-20">
        <p>
          <span className="font-semibold text-primary">The Challenge:</span>{" "}
          Emerald Jewel Industry, a titan in the jewelry manufacturing sector,
          was facing mounting pressure. A shortage of skilled manpower, coupled
          with soaring demand and evolving customer expectations, had begun to
          strain their production capabilities. The situation was
          critical—maintaining high productivity levels in the face of these
          challenges was no longer sustainable with the existing approach.
        </p>
        <p>
          <span className="font-semibold text-primary">
            The Strategic Breakthrough:
          </span>{" "}
          Emerald Jewel turned to us, confident in our ability to drive
          meaningful change. We knew that a surface-level fix wouldn’t suffice.
          Instead, we conducted a series of Gemba observations and in-depth
          discussions with key stakeholders. What we found was a need for a
          strategic shift—a transformation that would realign the company’s
          productivity program from being merely operational to becoming a
          cornerstone of strategic growth.
        </p>
        <p>
          <span className="font-bold text-primary">The Solution:</span> Our
          approach was holistic and precise. We redesigned the Industrial
          Engineering function, shifting the focus from day-to-day operations to
          long-term strategic initiatives. We targeted inefficiencies (muda) in
          the manufacturing processes, enhancing operator efficiency and
          breaking down silos between inter-units. This new focus on strategic
          productivity positioned Emerald Jewel not just to survive but to
          thrive in a competitive market.
        </p>
        <p>
          <span className="font-semibold text-primary">The Outcome:</span> The
          transformation was immediate and impactful. Accelerated training
          programs upskilled the workforce, while a revamped engineering
          structure eliminated waste and streamlined processes. The introduction
          of Relative Dynamic Service Levels (RDSL) as a customer satisfaction
          metric further cemented Emerald Jewel’s position as a leader in the
          industry. The company emerged not only more efficient but also more
          resilient, ready to meet the demands of a rapidly changing market with
          confidence.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default StrategicOverhaulProject;
